import React from 'react';
import { Table } from 'semantic-ui-react';
import NotAuthorised from '../errors/NotAuthorised';

const InEditCell = ({
  exists,
  canRead,
  children,
  colSpan,
  width,
}) => {
  if (!canRead) {
    return (
      <Table.Cell colSpan={colSpan} width={width}>
        <NotAuthorised />
      </Table.Cell>
    );
  }

  if (!exists) {
    return <Table.Cell colSpan={colSpan} width={width} />;
  }

  return (
    <Table.Cell colSpan={colSpan} width={width}>
      {children}
    </Table.Cell>
  );
};

export default InEditCell;
